import { h, Component } from 'preact'
import cxs from 'cxs'

import Input from 'app/components/Input'
import Form from 'app/components/Form'
import OptionsList from 'app/components/OptionsList'
import linkState from 'linkstate'
import { connect } from 'app/store'
import { api } from 'app/util/api'
import { Link } from 'preact-router'
import { removeProtocol } from 'app/util'
import { getFavicon } from '../util'

const boderClass = cxs({
  borderBottom: '1px solid #e6e5e6',
})

class BookmarkItem extends Component {
  state = {
    editing: false,
    initialBookmark: { ...this.props.bookmark },
    bookmark: { ...this.props.bookmark },
    tags: this.props.bookmark.tags.map(t => t.name).join(' '), // #tag #tag2 #tag3
  }

  toggleEditMode = () => {
    this.setState({ editing: !this.state.editing })
  }

  onSave = async () => {
    const { bookmark, tags } = this.state

    // Send request
    const saved = await api.patch('/bookmark/' + bookmark.id, {
      tags: tags ? tags.split(' ').filter(s => s !== '') : [],
      title: bookmark.title,
    })

    // Update state
    this.setState({
      bookmark: { ...saved },
      initialBookmark: { ...saved },
      tags: saved.tags.map(t => t.name).join(' '),
    })

    this.toggleEditMode()
  }

  onRemove = async () => {
    const { bookmark } = this.state

    if (!confirm('Sure?')) return

    this.props.removeBookmark(bookmark.id)
  }

  renderView() {
    const { tags, bookmark } = this.state

    const tagArray = tags.split(' ').filter(s => s !== '')

    const renderTags = () =>
      tagArray.length === 0
        ? null
        : tagArray.map(t => (
            <Link class="mx-1 text-muted" href={`/tags/${t}`}>
              #{t}
            </Link>
          ))

    return (
      <div>
        {/* Title */}
        <div>
          <img class="mr-2" src={getFavicon(bookmark.urlNormalized)} alt="favicon" />
          <b>{bookmark.title}</b>
          <span class="text-muted ml-2 font-sm">{bookmark.relativeTime}</span>
        </div>
        {/* Info */}
        <div class="my-1 font-sm">
          <a href={bookmark.urlNormalized} class="text-muted" target="_blank" rel="noopener">
            {removeProtocol(bookmark.url)}
          </a>{' '}
          {tags ? '~' : ''} {renderTags()}
        </div>
        {/* Options */}
        <button
          type="button"
          class="text-muted mr-2 btn-link font-sm"
          onClick={this.toggleEditMode}
        >
          edit
        </button>
        <button type="button" class="text-muted mr-2 btn-link font-sm" onClick={this.onRemove}>
          remove
        </button>{' '}
      </div>
    )
  }

  onCancelEdit = async () => {
    const { initialBookmark } = this.state

    const bookmark = { ...initialBookmark }
    const tags = initialBookmark.tags.map(t => t.name).join(' ')

    this.setState({ bookmark, tags })
    this.toggleEditMode()
  }

  renderEdit() {
    const { bookmark, tags } = this.state

    return (
      <Form onSubmit={() => this.onSave()}>
        {/* Title */}
        <Input
          placeholder="title"
          value={bookmark.title}
          onInput={linkState(this, 'bookmark.title')}
        />
        {/* Tags */}
        <Input placeholder="tags" autoFocus value={tags} onInput={linkState(this, 'tags')} />

        {/* Options */}
        <div class="mt-1 font-sm">
          <button class="text-muted mr-2 btn-link" type="submit">
            save
          </button>

          <button type="button" class="text-muted mr-2 btn-link" onClick={this.onCancelEdit}>
            cancel
          </button>
        </div>
      </Form>
    )
  }

  render() {
    const { editing, bookmark } = this.state

    return (
      <div class={`py-4 px-lg-4 px-md-4 px-xl-4 px-sm-2 ${boderClass}`}>
        {editing ? this.renderEdit(bookmark) : this.renderView(bookmark)}
      </div>
    )
  }
}

export default connect(
  null,
  BookmarkItem,
)



// WEBPACK FOOTER //
// ./components/BookmarkItem.js